var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0201 3.41003C8.71009 3.41003 6.02009 6.10003 6.02009 9.41003V12.3C6.02009 12.91 5.76009 13.84 5.45009 14.36L4.30009 16.27C3.59009 17.45 4.08009 18.76 5.38009 19.2C9.69009 20.64 14.3401 20.64 18.6501 19.2C19.8601 18.8 20.3901 17.37 19.7301 16.27L18.5801 14.36C18.2801 13.84 18.0201 12.91 18.0201 12.3V9.41003C18.0201 6.11003 15.3201 3.41003 12.0201 3.41003Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 3.69994C13.5599 3.60994 13.2399 3.53994 12.9099 3.49994C11.9499 3.37994 11.0299 3.44994 10.1699 3.69994C10.4599 2.95994 11.1799 2.43994 12.0199 2.43994C12.8599 2.43994 13.5799 2.95994 13.8699 3.69994Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 19.5601C15.02 21.2101 13.67 22.5601 12.02 22.5601C11.2 22.5601 10.44 22.2201 9.90002 21.6801C9.36002 21.1401 9.02002 20.3801 9.02002 19.5601",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.528beebc7ba4abcef0b34f1457d402f5.svg";
export { ForwardRef as ReactComponent };